export default {
  title: 'Cod promoțional',
  fields: {
    preset: {
      label: 'Presetare',
    },
    presets: {
      master: 'Master',
      campaign: 'Campanie',
      one_time: 'O singură dată',
    },
    code: {
      label: 'Cod',
      placeholder: 'Introduceți codul',
    },
    discount_type: {
      label: 'Tip reducere',
    },
    quantity: {
      label: 'Cantitate',
      placeholder: 'Infinit',
    },
    expires_at: {
      label: 'Dată de expirare',
      placeholder: 'Introduceți data sau lăsați gol',
    },
    franchise: {
      label: 'Cod promoțional Master pentru restaurant și/ sau pentru întregul brand',
    },
    discount: {
      label: 'Reducere',
    },
    usage_threshold: {
      label: 'Prag de utilizare',
    },
  },
  messages: {
    master_warning: 'Crearea unui nou cod promoțional „master" va expira codul promoțional master curent',
  },
  buttons: {
    save: 'Salvați',
    cancel: 'Anulați',
  },
  toasts: {
    promo_code_got_created: 'Codul promoțional a fost creat',
    promo_code_got_updated: 'Codul promoțional a fost actualizat',
  },
};
